var Buffer = require('buffer/').Buffer;
export var encode = function (input) {
    var encoded = Buffer.from(input, 'binary').toString('base64');
    return encoded;
};
export var decode = function (encoded) {
    var decoded = Buffer.from(encoded, 'base64').toString('binary');
    return decoded;
};
